export const orgOverrideConfig: Record<string, string[]> = {
  "8a546729-b46a-4375-ba25-28e741c2983d": ["NL", "BE", "DE"],
  "58aaf6a3-14c2-48f3-8016-284e0aa863aa": ["LU", "FR", "DE"],
  "e687ee72-4e6d-415b-a676-0f7e689632eb": ["GT", "HN", "SV"]
}
